import { render } from "./statistics.vue?vue&type=template&id=5a0bfeb2&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"

import "./statistics.vue?vue&type=style&index=0&id=5a0bfeb2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0bfeb2"]])

export default __exports__